<script lang="ts">
    import { onDestroy, onMount } from 'svelte'
    import { fade } from 'svelte/transition'

    import { gettext as _ } from 'hydria/services/gettext'

    interface Props {
        value: string
        close: () => void
        save: (v: string) => void
    }

    let { value, close = () => {}, save = (v) => {} }: Props = $props()

    let edit: string = $state('')
    let mainElement: HTMLInputElement | undefined = $state()

    function importValue(value: string) {
        edit = value
    }

    function isValid(value: string) {
        return value && value.length && value.length <= 50
    }

    onMount(() => {
        importValue(value)
        if (mainElement) {
            mainElement.focus()
            mainElement.select()
        }
        if (!document.documentElement.classList.contains('modal-open')) document.documentElement.classList.add('modal-open')
    })
    onDestroy(() => {
        if (document.documentElement.classList.contains('modal-open')) document.documentElement.classList.remove('modal-open')
    })
</script>

<svelte:window
    onkeydown={(e) => {
        if (e.key === 'Escape') {
            close()
        }
    }}
/>

<div class="modal modal-ds-records" role="dialog" transition:fade={{ duration: 250 }}>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form
                onsubmit={(e) => {
                    e.preventDefault()
                    save(edit)
                }}
            >
                <div class="modal-header text-bg-primary">
                    <div>{$_('Intended use for .quebec domains')}</div>
                </div>
                <div class="modal-body">
                    <div>
                        <input type="text" class="form-control" bind:value={edit} bind:this={mainElement} class:is-invalid={!isValid(edit)} />
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-primary" type="submit" disabled={!isValid(edit)}>{$_('Save')}</button>
                    <button class="btn btn-outline-secondary" type="button" onclick={() => close()}>{$_('Cancel')}</button>
                </div>
            </form>
        </div>
    </div>
    <div
        class="modal-backdrop"
        aria-hidden="true"
        onclick={() => {
            close()
        }}
    ></div>
</div>
